import React, { ReactElement, useContext } from 'react';
import { theming as surveyTheming } from '@sm/webassets';
import { t } from '@sm/intl';
import { Container } from '@sm/wds-react';
import COPY from '~app/pages/EnterpriseThankYou/copy';
import Logo from './components/Logo';
import Text from './components/Text';
import { HeaderPropsType, HeaderTypeEnum } from './types';
import { PageVariants, EnterpriseThankYouContext } from '~app/pages/EnterpriseThankYou';
import './header.scss';

const Header = ({ headerLogoUrl, headerText }: HeaderPropsType): ReactElement => {
  const { pageVariant } = useContext(EnterpriseThankYouContext);
  const { logo: surveyLogo } = useContext(surveyTheming.context);
  const premiumCustom = pageVariant === PageVariants.premiumCustom;

  const headerType = premiumCustom ? HeaderTypeEnum.PREMIUM : HeaderTypeEnum.STANDARD;
  const defaultSurveyLogoUrl = surveyLogo?.image?.url;
  const url = premiumCustom ? headerLogoUrl : defaultSurveyLogoUrl;

  const logo = {
    url,
    altText: t(COPY.LOGO_PLACEHOLDER),
  };

  return (
    <Container className="sm-header__outline">
      <Logo headerType={headerType} altText={logo.altText} url={logo.url} />
      <Text text={headerText} headerType={headerType} />
    </Container>
  );
};

export default Header;
